/*
 * noceve-ux.js — barre de progression de navigation.
 *
 * Ce que ça règle : entre le clic sur un produit et l'affichage de sa fiche, il
 * s'écoule un temps pendant lequel rien ne bouge. Le visiteur ne sait pas si son
 * clic a été pris. Il reclique, ou il repart.
 *
 * Ce que ça ne fait pas : masquer la page derrière un voile. Un écran de
 * chargement plein cadre cache un contenu déjà peint et allonge le temps
 * *perçu* — l'inverse du but recherché. Ici, deux pixels en haut, rien d'autre.
 *
 * La barre progresse par paliers décroissants et n'atteint jamais 100 % toute
 * seule : elle ne ment donc jamais sur un chargement qui n'est pas terminé.
 * C'est la page suivante, ou l'erreur, qui la termine.
 */
(() => {
  if (window.__nocProg) return;
  window.__nocProg = true;

  const barre = document.createElement('div');
  barre.className = 'noc-prog';
  barre.setAttribute('role', 'progressbar');
  barre.setAttribute('aria-hidden', 'true');
  document.documentElement.appendChild(barre);

  let avancement = 0;
  let minuteur = null;

  const poser = (v) => { barre.style.width = v + '%'; };

  const demarrer = () => {
    if (minuteur) return;
    avancement = 8;
    barre.classList.add('is-on');
    poser(avancement);
    minuteur = setInterval(() => {
      /* Palier de plus en plus petit : on approche sans jamais toucher. */
      const pas = avancement < 40 ? 6 : avancement < 70 ? 2.5 : 0.6;
      avancement = Math.min(avancement + pas, 92);
      poser(avancement);
    }, 220);
  };

  const finir = () => {
    if (!minuteur) return;
    clearInterval(minuteur);
    minuteur = null;
    poser(100);
    setTimeout(() => {
      barre.classList.remove('is-on');
      setTimeout(() => poser(0), 220);
    }, 180);
  };

  /* Navigation interne : on ignore les ancres, les nouveaux onglets, les
     téléchargements et tout ce qui n'est pas un vrai changement de page. */
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('download')) return;
    const href = a.getAttribute('href') || '';
    if (href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
    let url;
    try { url = new URL(a.href, location.href); } catch { return; }
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.search === location.search) return;
    demarrer();
  }, true);

  /* Ajout au panier et autres échanges avec le serveur : même signal. */
  const fetchOrigine = window.fetch;
  if (typeof fetchOrigine === 'function') {
    window.fetch = function (...args) {
      const cible = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      const suivi = /\/cart\/|\/cart\.js|\/products\/|\/search/.test(cible);
      if (suivi) demarrer();
      return fetchOrigine.apply(this, args).finally(() => { if (suivi) finir(); });
    };
  }

  /* Retour arrière depuis le cache du navigateur : la barre doit disparaître. */
  window.addEventListener('pageshow', finir);
  window.addEventListener('pagehide', finir);
  document.addEventListener('DOMContentLoaded', finir);
})();
